enum AllocationEventsTypes {
  Booking = 'Booking',
  TimeOff = 'TimeOff',
  Holiday = 'Holiday'
}

export default AllocationEventsTypes;
